import React from "react";
import { AddIcon, EditIcon } from "../../Assets/Icons";
import { useNavigate } from "react-router-dom";

const PlanFunctionButton = ({ uuid }) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="plan-actions">
        <span className="plan-button" onClick={() => navigate(`/organization/create/subscription/${uuid}`)}>
          <AddIcon />
          <p> Create New Subscription</p>
        </span>
        <span className="plan-button" onClick={() => navigate(`/organization/edit/${uuid}`)}>
          <EditIcon />
          <p> Edit Organization</p>
        </span>
      </div>
    </>
  );
};

export default PlanFunctionButton;
